import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MessageService } from 'primeng/api';
import { map, Observable } from 'rxjs';
import { AccountService } from 'src/app/auth/account.service';
import { StateStorageService } from '../services/state-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AccountGuard implements CanActivate {
  constructor(
    private router: Router,
    private messageService: MessageService,
    private accountService: AccountService,
    private stateStorageService: StateStorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.accountService.identity().pipe(
      map((res: any) => {
        const account = res?.data;
        
        if (account) {
          const authorities = route.data['authorities'];          
          if (!authorities || authorities.length === 0 || this.accountService.hasAnyAuthority(account, authorities)) {
            return true;
          }

          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access Denied' });
          this.router.navigate(['/auth/login']);
          return false;
        }

        this.stateStorageService.storeUrl(state.url);
        this.router.navigate(['/auth/login']);
        return false;
      })
    );
  }
  
}
